import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';

import CurrencyDisplay from 'components/Common/Currency/CurrencyDisplay';
import IncrementDecrement from 'components/Common/IncrementDecrement';
import { VEHICLE_TRACKING_FEATURE_NAME } from 'components/PayWall/Redux/Actions';
import { PayWallDuration } from 'components/PayWall/Redux/Reducer.type';
import { useTrackEventsService } from 'components/Services/Analytics/useTrackEventsService';

import { FeatureRowProps, useFeatureStyles } from './AddFeatureRow';
import { PAY_WALL_VERSION } from './PayWallDialog';
import { PriceDisplay } from './PayWallPlanSummary';

const getFeatureDuration = (featureName: string): typeof PayWallDuration | string => {
  if (featureName === VEHICLE_TRACKING_FEATURE_NAME) {
    return 'per month per device';
  }

  return PayWallDuration.Monthly;
};

const QuantifiableFeature = ({ hasPermissions, feature, onFeatureToggle }: FeatureRowProps) => {
  const classes = useFeatureStyles();
  const { trackEvent } = useTrackEventsService();

  return (
    <Grid
      container
      alignItems="center"
      justify="space-between"
      data-testid={`qunatifiable-feature-${feature.featureName}`}
    >
      <Grid item xs={5}>
        <Typography data-testid="feature-name">{feature.displayName}</Typography>
      </Grid>
      <Grid item xs={3} className={classes.rightAlign} data-testid={`${feature.featureName}-price`}>
        <PriceDisplay
          price={<CurrencyDisplay amountInCents={feature.price} decimalScale={0} />}
          duration={getFeatureDuration(feature.featureName)}
        />
      </Grid>
      <Grid item xs={4}>
        <IncrementDecrement
          hasPermissions={hasPermissions}
          initialValue={feature.quantity ?? 0}
          minimumValue={feature.minimalQuantity ?? 0}
          debounceTimeMsec={300}
          onChange={(newValue) => {
            onFeatureToggle(feature.featureName, feature.price, newValue > 0, newValue);
            trackEvent('PayWall addon quantity changed', {
              featureName: feature.featureName,
              featurePrice: feature.price,
              value: newValue,
              payWallVersion: PAY_WALL_VERSION,
            });
          }}
        />
      </Grid>
    </Grid>
  );
};

export default QuantifiableFeature;
